<template>
  <div class="tree-render">
    <ul :style="{ marginLeft: level*10 + 'px' }">
      <li
        v-for="item in list"
        :key="item.key"
      >
        <div class="titleContain">
          <span
            class="beforeTitle"
            :class="{
              haveChildren:item.children&&item.children.length>0,
              isExtend: item.expand,
              isClose: !item.expand
            }"
            @click.stop="changeExpend(item)"
          />
          <div
            class="titleContent"
            :class="{ selected: selected===item.id}"
            @click.stop="treeNodeSelected(item)"
          >
            <p
              :class="{
                'title-p':!item.del,
                'title-del-p': item.del
              }"
            >
              <span class="title-1">{{ item.name }}</span>
              <span
                v-if="level!==0"
                class="title-2"
              >
                {{ -item.level+'级负责人:'+(item.leaders||[]).map(item=>item.account).join('、') }}
              </span>
            </p>
            <div
              v-if="level===0"
              class="extend-operation"
            >
              <i-button
                v-if="haveExtraButton"
                size="small"
                type="primary"
                icon="ios-add"
                @click.stop="leveZeroClick"
              >
                添加部门
              </i-button>
            </div>
            <div
              v-if="(level!==0)&&haveExtraButton"
              class="extend-operation"
            >
              <span
                v-for="button in buttonList"
                :key="button.key"
              >
                <i-button
                  size="small"
                  :icon="button.type"
                  :disabled="item.del&&(button.key==='add'||button.key==='close')"
                  @click.stop="button.callBack(item)"
                />
              </span>
            </div>
          </div>
        </div>
        <div
          :class="{
            childrencContainisExtend: item.expand,
            childrencContainisClose: !item.expand,
          }"
        >
          <tree-render
            :list="item.children"
            :level="level+1"
            :call-back="callBack"
            :selected="selected"
            :have-extra-button="haveExtraButton"
          />
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
  import { PropsType, ButtonType } from './fields'
  import { FUNCTION } from './constants'
  export default {
    name:'TreeRender',
    props:PropsType,
    data() {
      return {
        index:0
      }
    },
    computed: {
      buttonList() {
        const { 
          edit = FUNCTION,
          add = FUNCTION,
          del = FUNCTION  
        } = this.callBack
        return ButtonType.call(this, edit, add, del)
      },
    },
    methods: {
      treeNodeSelected(item) {
        const { changeSelected = FUNCTION } = this.callBack
        changeSelected(item)
      },
      changeExpend(item) {
        if (!item.children || item.children.length === 0) return;
        item.expand = !item.expand
      },
      leveZeroClick() {
        const { add = FUNCTION } = this.callBack
        add()
      }
    },
  }
</script>

<style lang="less">
@import './style.less';
</style>
